export default "<div class=\"alert alert-info text-center\">\n  <i class=\"fa fa-lightbulb-o\"></i>&nbsp;\n  <ng-content></ng-content>\n</div>\n"